export class BaseCpnAcnInfo {
  companyPartNumber: string;
  fleetCode: string;
  aircraftNumber: string;
  position: string;
  noun: string;
  description: string;
  resourceCode: number;
  trackingLevel: number;
  cashItemFlag: string;
  etopsItemFlag?: any;
  unitQtyInstalled?: any;
  unitQtyServ?: any;
  unitQtyUnserv?: any;
  unitQtyPending?: any;
  qtyBo: number;
  qtyServ?: any;
  qtyOpenPo: number;
  qtyOpenSo: number;
  qtyShop?: any;
  qtyUnhd?: any;
  qtySurp?: any;
  qtyMrba?: any;
  classCd: number;
  altCc?: any;
  nha?: any;
  ata: string;
  ataChapter: string;
  ataDescription: string;
  ataGroup: string;
  effCd: string;
  qtyPerAcn?: any;
  qtyPerEng?: any;
  unitIssue: string;
  unhdFlag: string;
  globalAllocFlag: string;
  avgPrice: number;
  avgRepair?: any;
  primeMpn: string;
  primeFsc: string;
  stdPckgQty: number;
  avgPoLt: number;
  avgSoLt: number;
  scrapRate?: any;
  repairQty: number;
  titleIp: string;
  idIp: string;
  nameIp: string;
  emailIp: string;
  phoneIp: string;
  titleRts: string;
  idRts: string;
  nameRts: string;
  emailRts: string;
  phoneRts: string;
  titleWnty: string;
  idWnty: string;
  nameWnty: string;
  emailWnty: string;
  phoneWnty: string;
  titleOms: string;
  idOms: string;
  nameOms: string;
  emailOms: string;
  phoneOms: string;
  caseCntRogue: number;
  caseCntBfs: number;
  caseCntRptAcn: number;
  demandQty_12Month: number;
  demandAvg_12Month: number;
  demandQty_36Month: number;
  demandAvg_36Month: number;
  demandQty_60Month: number;
  demandAvg_60Month: number;
  fleets?: any;
  installedFleets?: string;
  mechFlag: number;
  excluded: number;
  engineInd: number;
  apuInd: number;
  activeInstalls?: any;
  installedSims?: any;
  simulatorAbleCpn?: any;
  cycleDrivenIndicator: number;
  isOverhaulableIndicator: number;
  cpnInfounitSpec: number;
  cpnInfoMpnSpec: number;
  cpnInfoCpnHardSpec: number;
  subAssemblyIndicator: number;
  lruIndicator: number;
  cpn5YearPainSum: number;
  cpn5Year02BfsRemovalCount: number;
  cpn5YearAverage02BfsPainCost: number;
  aircraftFlag: string;
  serviceOrderCost5Year: number;
  serviceOrderAverageCost5Year: number;
  m2Count5Year: number;
  unscheduledRemovalCount5Year: number;
  m2DelayRate5Year: number;
  averagePainCost5Year: number;
  painCost5Year: number;
  materielInventoryDaysOnHand: number;
  materielInventoryDaysOnHandStatus: string;
  crtInventoryDaysOnHand: number;
  crtInventoryDaysOnHandStatus: string;
  crtInventoryDaysOnHandWithBuffer: number;
  crtInventoryDaysOnHandStatusWithBuffer: string;
  crtInventoryDaysOnHandWithBufferAllOrders: number;
  crtInventoryDaysOnHandStatusWithBufferAllOrders: string;
  crtInventoryDaysOnHandWithBuffer60DayOrders: number;
  crtInventoryDaysOnHandStatusWithBuffer60DayOrders: string;
  crtInventoryDaysOnHandWithBuffer30DayOrders: number;
  crtInventoryDaysOnHandStatusWithBuffer30DayOrders: string;
  crtInventoryDaysOnHandStatusConsolidatedBufferOrders: string;
  removedNotUnscheduledRate5Year: number;
  tsiCorruptedIndicator: number;
}
